import { SeekbarInfo } from '../PlayerModel';
import { StreamInfo } from '../streamInfo/StreamInfo';

export class UiEventHandlers {
  updateTitleBarHandler: (info: StreamInfo) => void;
  spinnerHandler: (enabled: boolean) => void;
  errorHandler: (msg: string | undefined) => void;
  updatePosition: (info: SeekbarInfo) => void;
  updateControlButtons: (buttons: string[]) => void;
  updateTrickPlay: (forward: boolean, speed: number) => void;
  constructor() {
    this.updateTitleBarHandler = () => {
      return;
    };
    this.spinnerHandler = () => {
      return;
    };
    this.errorHandler = () => {
      return;
    };
    this.updatePosition = () => {
      return;
    };
    this.updateControlButtons = () => {
      return;
    };
    this.updateTrickPlay = () => {
      return;
    };
  }
}
